import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class BankReferenceService extends BaseReferenceService {
  constructor() {
    super('BankReference');
  }
  getForCurrency(currencyId: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetForCurrency/${currencyId}`);
  }
}
